import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CreatorStateService } from '../app-services';
import { AbstractRestService } from '../../../../core/services/AbstractRestService';
import { IShape } from '../../interfaces';
import { ShapeSeatTypes, ShapeTypes } from '../../enums';
import { DEFAULT_SCREEN_COLOR, DEFAULT_SEAT_COLOR } from '../../constants';
import { ElementTypes } from '../../enums/ElementTypes';

@Injectable({
  providedIn: 'root'
})
export class ShapesApiService extends AbstractRestService<IShape> {

  protected readonly basePath = '/auditoriums/shapes';

  public override getAll(sectors?: boolean): Observable<IShape[]> {
    return this.apiService.get(`${this.basePath}/all?sectors=${sectors}&isForNewCashApp=${CreatorStateService.seatsPlan.isForNewCashApp}`).pipe(
      tap(shapes => CreatorStateService.libraryShapes = shapes)
    );
  }
}
